module.exports = __webpack_public_path__ + "img/33.8d7a7a5b.png";